"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmenAbilityHandler = exports.OmenActorAbilityFactory = exports.OmenAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Curse_1 = require("../../core/effects/core/Curse");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const Instant_1 = require("../../core/vfx/core/Instant");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class OmenAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Omen;
        this.__typeName = "Omen";
    }
}
exports.OmenAbilityArgs = OmenAbilityArgs;
let OmenActorAbilityFactory = class OmenActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Omen", "OneEnemies", 0);
    }
};
OmenActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Omen")
], OmenActorAbilityFactory);
exports.OmenActorAbilityFactory = OmenActorAbilityFactory;
let OmenAbilityHandler = class OmenAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        sequence.push(core_1.CameraVfxStepArgs.Alpha(.3));
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 45)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Curse_1.CurseEffectArgs("Focus", 10),
                    onApplied: (sequence) => {
                        sequence.pushSequence("sequential")
                            .push(new Instant_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "chest"), "Omen", true));
                    },
                });
            },
            onHitOrMiss: (sequence) => {
                sequence.push(core_1.CameraVfxStepArgs.AlphaReset());
            }
        });
    }
};
OmenAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Omen)
], OmenAbilityHandler);
exports.OmenAbilityHandler = OmenAbilityHandler;
